
import CpntBlocPresentationDetail from "../../components/CpntBlocPresentationDetail";
import { ContactSujetIds } from "../../config/helpers";
import img_achat_fichiers_1 from "../../images/presentation/achat_fichiers_1.png"
import "./PagePresentation.scss"


const description1 =
  <>
    <p>
    Vous recherchez des informations précises sur le marché du livre ou des données structurantes pour compléter vos bases ?<br/> Que ce soit pour une veille stratégique, un projet éditorial ou une analyse commerciale, nous vous fournissons des fichiers personnalisés, adaptés à vos besoins.
    </p>
<b>Exemples de demandes possibles :</b>
<ul>
<li>La liste de tous les ouvrages parus sur le thème de l&apos;IA en 2024</li>
<li>Le fichier des auteurs (ISNI)</li>
<li>Les titres dont le prix a été modifié le mois dernier</li>
<li>La bibliographie complète des auteurs de votre choix</li>
</ul>
   
</>
;

const description2 =
  <>
  <div className="mt-4">
        <p className="text-md-start text-justify">
        Nous collectons et organisons ces données pour vous, et vous les livrons dans un format <b>Excel clair et exploitable</b>, prêt à être utilisé.<br/>
        <b>Vous bénéficiez d&apos;informations fiables et actualisées. Contactez-nous pour obtenir un fichier sur mesure !</b>
      </p>
    </div>
  </>
;


const PagePresentation_AchatFichier = () => {

   return (
    <>
    <div className="row pt-3 pb-5">
      <div className="col col-md-10 offset-md-1 col-12 ">
        <div className="titre titre-Presentation text-center">Achat de fichiers</div>
      </div>
    </div>
        <CpntBlocPresentationDetail
          description1={description1}
        description2={description2}
          img_rond={img_achat_fichiers_1}
          linktext="Nous contacter"
          contactsujet={ContactSujetIds.AchatDeFichiers}
        />
      </>
  );
};

export default PagePresentation_AchatFichier;
